import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "../../components/site/Logo";
import { api, formatErr } from "../../lib/api";
import { Seo } from "../../components/site/Seo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [st, setSt] = useState({ loading: false, error: "" });

  const submit = async (e) => {
    e.preventDefault();
    setSt({ loading: true, error: "" });
    try {
      const { data } = await api.post("/auth/login", f);
      localStorage.setItem("ari_token", data.token);
      nav("/admin");
    } catch (err) {
      setSt({ loading: false, error: formatErr(err) });
    }
  };

  return (
    <div data-testid="admin-login-page" className="noise relative flex min-h-screen items-center justify-center bg-[#07090e] px-5">
      <Seo title="Admin login | Autocrat Rubber Industries" description="Admin area." noindex />
      <div className="grid-lines absolute inset-0" />
      <form onSubmit={submit} className="clip-corner relative w-full max-w-md bg-[#0d121b] p-8 sm:p-10" data-testid="admin-login-form">
        <Logo />
        <h1 className="font-display mt-10 text-4xl font-extrabold uppercase text-white">Admin login</h1>
        <p className="mt-2 text-sm text-slate-400">Manage products, media and RFQs.</p>
        <label className="mt-8 block">
          <span className="eyebrow !text-[10px] text-slate-400">Email</span>
          <input data-testid="admin-login-email" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })}
            className="mt-2 w-full border border-slate-700 bg-[#07090e] px-4 py-3 text-white outline-none focus:border-sky-400" />
        </label>
        <label className="mt-5 block">
          <span className="eyebrow !text-[10px] text-slate-400">Password</span>
          <input data-testid="admin-login-password" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })}
            className="mt-2 w-full border border-slate-700 bg-[#07090e] px-4 py-3 text-white outline-none focus:border-sky-400" />
        </label>
        {st.error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{st.error}</p>}
        <button data-testid="admin-login-submit" disabled={st.loading} className="btn-electric mt-8 w-full disabled:opacity-60">
          {st.loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Lock className="h-4 w-4" /> Sign in</>}
        </button>
      </form>
    </div>
  );
}
